import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import { UserData, UserPreview } from '@bizzabo/entities';

import VideoLargeNotification from '../VideoLargeNotification';
import VideoSmallNotification from '../VideoSmallNotification';
import useTypeTracking from '../../../analytics';
import { IncomingNotification } from '../atoms';
import { useNotificationSize } from '../../hooks/useNotificationSize';

export interface VideoNotificationWrapperProps {
    currentUser: UserData;
    callerUser: UserPreview;
    incomingNotification: IncomingNotification;
}

const VideoNotificationWrapper: React.FC<VideoNotificationWrapperProps> = ({
    currentUser,
    callerUser,
    incomingNotification,
}) => {
    const classes = useStyles();
    const { isLargeNotification, setUserMinimized, isDesktop } = useNotificationSize();

    const { Track, trackClickEvent } = useTypeTracking({
        data: {
            description: {
                notification_type: isLargeNotification ? 'big' : 'minimized',
                meeting_id: incomingNotification.meetingId,
                meeting_type: 'instant',
                is_host: currentUser.userProfileId === incomingNotification.callerUserProfileId,
            },
        },
    });

    const minimizeHandle = () => {
        setUserMinimized(true);
        trackClickEvent({
            buttonType: 'VIDEO_NOTIFICATIONS',
            subCategory: 'MINIMIZED_MEETING_REQUEST',
        });
    };

    return (
        <Track>
            <div
                className={clsx(classes.main, {
                    [classes.largeNotification]: isLargeNotification,
                    [classes.smallNotification]: !isLargeNotification,
                })}
            >
                {isLargeNotification ? (
                    <VideoLargeNotification
                        currentUser={currentUser}
                        callerUser={callerUser}
                        minimizeHandle={minimizeHandle}
                    />
                ) : (
                    <VideoSmallNotification
                        currentUser={currentUser}
                        callerUser={callerUser}
                        isDesktop={isDesktop}
                    />
                )}
            </div>
        </Track>
    );
};
const useStyles = makeStyles(
    theme => ({
        main: {
            position: 'absolute',
            zIndex: 2000,
            transition: 'all 0.5s',
        },
        largeNotification: {
            width: '45%',
            maxWidth: '360px',
            height: 500,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        smallNotification: {
            top: 60,
            left: '50%',
            transform: 'translateX(-50%)',
            height: 64,
            display: 'flex',
            justifyContent: 'space-between',
            padding: 16,
            backgroundColor: theme.palette.greys[800],
            borderRadius: 25,
            [theme.breakpoints.up('sm')]: {
                top: 24,
            },
        },
    }),
    { classNamePrefix: 'video-notification-wrapper' }
);
export default VideoNotificationWrapper;
